import React,{useEffect} from 'react';
import NoticeUtil from '../utils/NoticeUtil';
import CommonIn from '../utils/CommonIn';

const Notice = () => {
  const { prevPage, nextPage } = NoticeUtil()
  useEffect(() => {
    // AOS.init();
    CommonIn();
  }, []);
  return (
    <>
     
      <main className="submain" id="submain">
        <div className="sub_header">
          <div className="container sub_header_inner">
            <h1>고객지원</h1>
          </div>
        </div>
        <div className="submenu">
          <div className="container">
            <div className="submenu_inner">
              <ul>
                <li><a href="/support">FAQ</a></li>
                <li><a href="/notice" className="active">공지사항</a></li>
              </ul>
            </div>
          </div>
        </div>
        <section className="visual_sec solution_vs">
          <div className="container visual_inner">
            <div className="visual_text">
              <h2>공지사항</h2>
              <p>찾으시는 답변이 없으신가요?<br />언제든지 문의해 주시면 빠르게 답변드리겠습니다.</p>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <article className="notice-wrapper">
              <div className="notice-item">
                <div className="notice_txt">
                  <h3 className="notice-itme-title">Server maintenance notice</h3>
                  <p className="notice-item-date">2025.01.01</p>
                </div>
                <div className="arrow"><img src="assets/images/btn_arrow.png" alt="arrow" /></div>
              </div>
            </article>
            <div className="notice-pagination-wrapper">
              <button aria-hidden="true" onClick={() => prevPage('start')} onKeyDown={() => prevPage('start')} tabIndex="0">
                <i className="las la-angle-double-left"></i>
              </button>
              <button aria-hidden="true" onClick={() => prevPage('one')} tabIndex="0">
                <i className="las la-angle-left"></i>
              </button>
              <ul className="notice-pagination"></ul>
              <button aria-hidden="true" onClick={() => nextPage('one')} tabIndex="0">
                <i className="las la-angle-right"></i>
              </button>
              <button aria-hidden="true" onClick={() => nextPage('end')} tabIndex="0">
                <i className="las la-angle-double-right"></i>
              </button>
            </div>
          </div>
        </section>
      </main>
     
    </>
  );
};

export default Notice;